import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "prefix-value value-item"
};
const _hoisted_2 = { class: "font-italic" };
const _hoisted_3 = { class: "search-input autocomplete mt-2" };
const _hoisted_4 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnFilterButtonBase"], {
        modelValue: $setup.menuIsVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.menuIsVisible) = $event)),
        "display-string": $setup.displayString,
        "reset-filter": $setup.resetFilter,
        id: $setup.returnFilterButtonId($props.id),
        "is-action-buttons-rendered": false
    }, {
        label: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        prefix: _withCtx(() => [
            ($setup.hasDisplayPrefix)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString($setup.displayPrefix), 1 /* TEXT */)
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
                ($props.label)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.label), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createVNode($setup["EnAutocompleteComponent"], {
                    ref: "enAutocomplete",
                    modelValue: $setup.currentOption,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.currentOption) = $event)),
                    "display-expression": $props.displayExpression,
                    "search-expression": $props.searchExpression,
                    "select-expression": $props.selectExpression,
                    "search-value": $props.searchValue,
                    "api-uri": $props.apiUri,
                    rules: $props.rules,
                    group: $props.group,
                    "hide-null-values": $props.hideNullValues,
                    items: $props.items,
                    "item-value": $props.itemValue,
                    hint: $props.hint,
                    id: $setup.returnId($props.id),
                    autofocus: $setup.hasAutofocus,
                    "reload-on-focus-in": $setup.hasAutofocus && !!$props.apiUri && (!$props.items || $props.items.length === 0),
                    "preselected-object": $setup.preselectedValue,
                    "use-contains": $props.useContains,
                    "items-per-page": $props.itemsPerPage,
                    dense: "",
                    "persistent-hint": "",
                    clearable: "",
                    onKeyup: _withKeys($setup.confirmWithEnter, ["enter"]),
                    onEnterPressed: $setup.confirmWithEnter,
                    onMounted: $setup.autocompleteRendered,
                    onBlur: $setup.blur,
                    onSetHasPrefix: _cache[1] || (_cache[1] = val => $setup.hasDisplayPrefix = val)
                }, null, 8 /* PROPS */, ["modelValue", "display-expression", "search-expression", "select-expression", "search-value", "api-uri", "rules", "group", "hide-null-values", "items", "item-value", "hint", "id", "autofocus", "reload-on-focus-in", "preselected-object", "use-contains", "items-per-page"])
            ])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "display-string", "reset-filter", "id"]));
}
